var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountPercentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0668 2.33826C11.193 1.42208 12.8076 1.42208 13.9338 2.33826L14.4719 2.77594L15.1567 2.66592C16.5901 2.4356 17.9885 3.24292 18.5056 4.59947L18.7527 5.24753L19.4009 5.49465C20.7574 6.01192 21.5648 7.41022 21.3344 8.84366L21.2244 9.52846L21.6621 10.0665C22.5783 11.1927 22.5783 12.8074 21.6621 13.9336L21.2244 14.4716L21.3344 15.1564C21.5648 16.5899 20.7574 17.9883 19.4009 18.5054L18.7527 18.7525L18.5056 19.4007C17.9885 20.7572 16.5901 21.5645 15.1567 21.3341L14.4719 21.2241L13.9338 21.6618C12.8076 22.5781 11.193 22.5781 10.0668 21.6618L9.5287 21.2241L8.8439 21.3341C7.41047 21.5645 6.01217 20.7572 5.4949 19.4007L5.24778 18.7525L4.59971 18.5054C3.24316 17.9883 2.43585 16.5899 2.66617 15.1564L2.77618 14.4716L2.3385 13.9336C1.42232 12.8074 1.42232 11.1927 2.3385 10.0665L2.77618 9.52846L2.66617 8.84366C2.43585 7.41022 3.24316 6.01192 4.59971 5.49465L5.24778 5.24753L5.4949 4.59947C6.01217 3.24292 7.41047 2.4356 8.8439 2.66592L9.5287 2.77594L10.0668 2.33826Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01953 15.9804L15.9802 8.01965",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8156 9.6118C9.25526 9.6118 9.61167 9.25538 9.61167 8.81572C9.61167 8.37607 9.25526 8.01965 8.8156 8.01965C8.37595 8.01965 8.01953 8.37607 8.01953 8.81572C8.01953 9.25538 8.37595 9.6118 8.8156 9.6118Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1847 15.9803C15.6244 15.9803 15.9808 15.6239 15.9808 15.1843C15.9808 14.7446 15.6244 14.3882 15.1847 14.3882C14.7451 14.3882 14.3887 14.7446 14.3887 15.1843C14.3887 15.6239 14.7451 15.9803 15.1847 15.9803Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountPercentIcon);
export default __webpack_public_path__ + "static/media/Discount-Percent-Icon.b9970b4dd5058d31665f884e76536de7.svg";
export { ForwardRef as ReactComponent };